import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const ModifyTicketPriorityType = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);

	const ticketPriorityTypeInputRef = useRef();
	const remarkInputRef = useRef();

	const [dataToBeSelect, setDataToBeSelect] = useState([]);

	const [editData, setEditData] = useState([]);
	const [inputError, setInputError] = useState([]);

    useEffect(() => {
		if (props.editData !== null) {
			setEditData({
				TICKET_PRIORITY_TYPE_ID: props.editData.TICKET_PRIORITY_TYPE_ID,
				TICKET_PRIORITY_TYPE_NAME: props.editData.TICKET_PRIORITY_TYPE_NAME,	
				REMARK: props.editData.REMARK === null ? "" : props.editData.REMARK,
			});

		}
	}, [props.editData]);

	//#region Modal Show/Hide
	const hideModal = () => {
		// setEditData([]);
		setInputError([]);
		props.onHide();
	};
	//#endregion

	const saveBtnOnClick = () => {

		if (Object.values(inputError).filter(v => v !== "").length === 0) {
			ModifyTicketPriorityType();
		}
	}

    function ModifyTicketPriorityType() {
		let functionName = "";
		try {
			functionName = ModifyTicketPriorityType.name;
			props.onLoading(true, "Modifying ticket priority type, please wait...");
			
			const data = {
				TICKET_PRIORITY_TYPE_ID: editData.TICKET_PRIORITY_TYPE_ID,
				TICKET_PRIORITY_TYPE_NAME: editData.TICKET_PRIORITY_TYPE_NAME.trim(),
				REMARK: editData.REMARK === undefined ? "" : editData.REMARK.trim(),
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};
			http
				.put("api/TicketPriorityType/UpdateTicketPriorityType", data, { timeout: 5000 })
				.then((response) => {
					if (response.data.DUPLICATE_TICKET_PRIORITY_TYPE_NAME === true) {
						toast.error("Ticket priority type already exist.");
					} else {
						toast.success("Ticket priority type is successfully inserted.");
						props.onReload();
						hideModal();
					}
				})
				.catch((err) => {
					toast.error("Failed to modify ticket priority type. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to modify ticket priority type. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

    const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setEditData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

	const inputUnrequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputUnrequiredHandler.name;
			const name = event.target.name;
			functionName = inputUnrequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;

			setEditData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

    return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "lightgrey", width: "100%" }}>
						<Modal.Title>MODIFY</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Comp.Input
						ref={ticketPriorityTypeInputRef}
						id="TICKET_PRIORITY_TYPE_NAME"
						label="Ticket Priority Type*:"
						name="Ticket Priority Type"
						type="text"
						className="form-control"
						errorMessage={inputError.TICKET_PRIORITY_TYPE_NAME}
						value={editData.TICKET_PRIORITY_TYPE_NAME}
						onChange={inputRequiredHandler}
					/>
                    <Comp.Input
						ref={remarkInputRef}
						id="REMARK"
						label="Remark:"
						type="text"
						className="form-control"
						value={editData.REMARK}
						onChange={inputUnrequiredHandler}
					/>
				</Modal.Body>
				<Modal.Footer>
					<div style={{ textAlign: "center", width: "100%" }}>
						<Comp.Button id="btnSave" onClick={saveBtnOnClick}>
							Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={hideModal}
						>
							Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);

};

export default ModifyTicketPriorityType;